import { useState, useEffect, useRef } from "react";

import PageLayout from "../../../components/PageLayout/PageLayout";

import Button from "../../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import "./NewSaleSerialNumber.scss";
import { FieldErrors, useForm, Controller } from "react-hook-form";
import { registerVisit } from "../../../store/actions/activations";
import { useSelector } from "react-redux";
import { getRegisterProgress } from "../../../store/reducers/activations";
import { useAppDispatch } from "../../../hooks";
import { API_URL, appFetch } from "../../../helpers/fetch";
import { useAppSelector } from "../../../hooks";

import Select from "react-select";

import { showDrawer } from "../../../store/actions/ui";

import veoArctic from "./img/veo-arctic-click.png";
import veoScarletClick from "./img/veo-scarlet-click.png";
import veoGreenClick from "./img/veo-green-click.png";
import veoVioletClick from "./img/veo-violet-click.png";

import checked from "./img/yes.svg";
import unchecked from "./img/no.svg";
import { getToken } from "../../../store/reducers/user";

import { getPeriodStats } from "../../../store/reducers/account";
import LukiesRed from "./img/luckies_red_ks.png";
import LuckiesBlue from "./img/luckies_blue_ks.png";
import LuckiesGreen from "./img/luckies_green_ssl.png";
import LuckiesBlueSSL from "./img/luckies_blue_ssl.png";

const productsListItem = [
  {
    value: "luckies_red_ks",
    label: "LUCKIES RED KS",
    img: LukiesRed,
    // prize: "10 zł",
  },
  {
    value: "luckies_blue_ks",
    label: "LUCKIES BLUE KS",
    img: LuckiesBlue,
  },
  {
    value: "luckies_green_ssl",
    label: "LUCKIES GREEN SSL",
    img: LuckiesGreen,
  },
  {
    value: "luckies_blue_ssl",
    label: "LUCKIES BLUE SSL",
    img: LuckiesBlueSSL,
  },
  // {
  //   value: "neo_green",
  //   label: "neo™ Green",
  //   img: pNeoGreen,
  //   prize: "10 zł",
  // },
  // {
  //   value: "neo_blue",
  //   label: "neo™ Blue",
  //   img: pNeoBlue,
  //   prize: "10 zł",
  // },
  // {
  //   value: "neo_scarlet",
  //   label: "neo™ Scarlet",
  //   img: pNeoScarlet,
  //   prize: "10 zł",
  // },
  // {
  //   value: "neo_violet",
  //   label: "neo™ Violet",
  //   img: pNeoViolet,
  //   prize: "10 zł",
  // },
  // {
  //   value: "kent_glo_emerald_green",
  //   label: "Kent for glo™ Emerald Green",
  //   img: pKent,
  //   prize: "10 zł",
  // },
  // {
  //   value: "neo_summer",
  //   label: "neo™ Summer",
  //   img: pNeoSummer,
  //   prize: "10 zł",
  // },
];

const PackhotsCartSelect = ({
  set,
  set1,
  setSet1,
  availableSet1,
  availableSet2,
  set2,
  setSet2,
  uuidSelected,
}: any) => {
  return (
    <>
      <h3>Wybierz sprzedane zestawy</h3>
      {/* {...register("serial", {required: true, minLength: 1, maxLength: 64})} */}
      <div className="pick-wrapper">
        <div className="input-item checkboxs-wrapper">
          <div
            className={set1 || !availableSet1 ? "set checked" : "set"}
            style={availableSet1 ? {} : { opacity: "0.5" }}
            onClick={
              availableSet1 ? () => setSet1(!set1) : (e) => e.preventDefault()
            }
          >
            <div className="title-wrapper">
              <h4>
                Koszyk 1 <span>Nagroda: 25 zł</span>
              </h4>
              <img src={set1 || !availableSet1 ? checked : unchecked}></img>
            </div>
            <div className="sets-wrapper">
              <div className="set-wrapper">
                <img src={veoArctic} alt="VEO Arctic Click " />
                <div className="set-heading-wrapper">
                  <strong>VEO Arctic Click </strong>
                  <p>min. 5 paczek</p>
                </div>
              </div>
              <div className="set-wrapper">
                <img src={veoScarletClick} alt="VEO Arctic Click " />
                <div className="set-heading-wrapper">
                  <strong>VEO Scarlet Click </strong>
                  <p>min. 5 paczek</p>
                </div>
              </div>
            </div>
          </div>
          <div
            className={set2 || !availableSet2 ? "set checked" : "set"}
            style={availableSet2 ? {} : { opacity: "0.5" }}
            onClick={
              availableSet2 ? () => setSet2(!set2) : (e) => e.preventDefault()
            }
          >
            <div className="title-wrapper">
              <h4>
                Koszyk 2 <span>Nagroda: 25 zł</span>
              </h4>
              <img src={set2 || !availableSet2 ? checked : unchecked}></img>
            </div>
            <div className="sets-wrapper">
              <div className="set-wrapper">
                <img src={veoGreenClick} alt="PALL MALL FLOW BLUE 20 KS" />
                <div className="set-heading-wrapper">
                  <strong>VEO Green Click </strong>
                  <p>min. 5 paczek</p>
                </div>
              </div>
              <div className="set-wrapper">
                <img src={veoVioletClick} alt="PALL MALL FLOW RED 20 KS" />
                <div className="set-heading-wrapper">
                  <strong>VEO Violet Click</strong>
                  <p>min. 5 paczek</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Button
          disabled={!set1 && !set2}
          color={!set1 && !set2 ? "grey" : "blue"}
          onClick={() => {
            registerVisit(uuidSelected);
            // alert("register");
          }}
        >
          Otrzymaj nagrodę
        </Button>
      </div>
    </>
  );
};
const PackhotsProductSelect = ({ availableProducts, onSubmit }: any) => {
  const [selected, setSelected] = useState<string[]>([]);

  const toggle = (value: string) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  return (
    <div className="products-select">
      <h3>Wybierz sprzedane produkty</h3>
      <p className="desc">
        <strong>
          <span className="desktop">Premia od 2 SKU.</span>
        </strong>{" "}
        2 warianty – 20 zł <br className="only-mobile" />• 3 warianty – 35 zł •
        4 warianty – 60 zł.{" "}
      </p>

      <div className="pick-wrapper">
        <div className="input-item checkboxs-wrapper">
          {productsListItem.map((p, i) => {
            const available = Boolean(availableProducts?.[p.value]);

            // 🔥 KLUCZOWA LINIA — identyczna logika jak w koszykach
            const isChecked = selected.includes(p.value) || !available;

            return (
              <div
                key={p.value}
                className={isChecked ? "set checked" : "set"}
                style={available ? {} : { opacity: "0.5" }}
                onClick={
                  available
                    ? () => toggle(p.value)
                    : (e: any) => e.preventDefault()
                }
              >
                <div className="title-wrapper">
                  <div>
                    <h4>Produkt {i + 1}</h4>
                    {/* <span>Nagroda {p.prize}</span> */}
                  </div>
                  <img src={isChecked ? checked : unchecked} alt="" />
                </div>

                <div className="sets-wrapper">
                  <div className="set-wrapper">
                    <img src={p.img} alt={p.label} />
                    <div className="set-heading-wrapper">
                      <strong>{p.label}</strong>
                      {/* <p>min. 5 paczek</p> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <Button
          disabled={selected.length === 0}
          color={selected.length === 0 ? "grey" : "blue"}
          onClick={() => onSubmit(selected)}
        >
          Zarejestruj sprzedaż
        </Button>
      </div>
    </div>
  );
};

function NewSaleSerialNumber() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
  } = useForm();
  const registerInProgress = useSelector(getRegisterProgress);
  const december = new Date() > new Date("2023-12-01T23:59:00.000");
  const [inputState, setInputState] = useState("");
  const [nipState, setNipState] = useState("");
  const [nfpState, setNfpState] = useState("");
  const [uuidSelected, setUuidSelected] = useState("");
  const [step, setStep] = useState(1);
  const [set1, setSet1] = useState(false);
  const [set2, setSet2] = useState(false);
  const [availableSets, setAvailableSets] = useState([]);
  const [availableSet1, setAvailableSet1] = useState(false);
  const [availableSet2, setAvailableSet2] = useState(false);
  const [availableProducts, setAvailableProducts] = useState({
    luckies_red_ks: true,
    luckies_blue_ks: true,
    luckies_green_ssl: true,
    luckies_blue_ssl: true,
  });

  const [branchsList, setBranchsList] = useState([{ value: "", label: "" }]);
  const [showBranchSelect, setShowBranchSelect] = useState(false);
  const periodData = useAppSelector(getPeriodStats);
  const sellIsActive = periodData?.currentPeriod?.isActive;

  const token = useSelector(getToken);

  // const { width, height } = useWindowDimensions();

  useEffect(() => {
    //block entering this page
    if (!sellIsActive) {
      navigate("/dashboard");
    }
  }, [inputState]);

  const successCallback = () => {
    setStep(1);
    navigate("/rejestracja-wizyty/success");
  };

  const onError = (errors: FieldErrors) => {
    //console.log(errors)
  };
  // @ts-ignore

  const selectInputRef = useRef<any>(null);

  const validatSAPid = async (uuid: any, nfp: any) => {
    appFetch(
      "POST",
      API_URL,
      "/sap/register",
      {
        sap: {
          uuid: uuid,
        },
      },
      token?.uuid ? token?.uuid : false,
      (result: any) => {
        if (result.status && result.status.success) {
          registerVisit(result.data.uuid);
        } else {
          dispatch(
            showDrawer("error", {
              name: result.data.error,
              errorCode: result.meta.ts,
            }),
          );
        }
      },
      () => {},
    );
  };

  const registerVisit = async (
    uuidFromValidation: any,
    selectedProducts = [],
  ) => {
    if (registerInProgress) return;

    //Dont touch old
    // let sendSets: any = [];
    // if (set1 && availableSet1) {
    //   // @ts-ignore
    //   sendSets = ["zestaw_3", ...sendSets];
    // }
    // if (set2 && availableSet2) {
    //   // @ts-ignore
    //   sendSets = [...sendSets, "zestaw_4"];
    // }

    console.log(
      uuidFromValidation,
      "uuidFromValidation",
      selectedProducts,
      "selectedProducts",
    );

    // if (!registerInProgress) {
    //   dispatch(registerVisit(serial, navigate, sendSets));
    // }
    // appFetch(
    //   "POST",
    //   API_URL,
    //   "/visit/register",
    //   {
    //     visit: {
    //       productSet: sendSets,
    //     },
    //     sap: {
    //       uuid: uuidFromValidation,
    //     },
    //   },
    //   token?.uuid ? token?.uuid : false,
    //   (result: any) => {
    //     if (result.status && result.status.success) {
    //       navigate("/rejestracja-wizyty/success");
    //     } else {
    //       dispatch(
    //         showDrawer("error", {
    //           name: result.data.error,
    //           errorCode: result.meta.ts,
    //         })
    //       );
    //     }
    //   },
    //   () => {}
    // );
    appFetch(
      "POST",
      API_URL,
      "/visit/register",
      {
        visit: {
          product: selectedProducts,
        },
        sap: {
          uuid: uuidFromValidation,
        },
      },
      token?.uuid ? token?.uuid : false,
      (result: any) => {
        if (result.status && result.status.success) {
          navigate("/rejestracja-wizyty/success");
        } else {
          dispatch(
            showDrawer("error", {
              name: result.data.error,
              errorCode: result.meta.ts,
            }),
          );
        }
      },
      () => {},
    );
  };

  const loadOptionsBranchStatic = (nip: any) => {
    fetch(API_URL + "/sap/list", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token.uuid,
      },
      body: JSON.stringify({ sap: { nip: nip } }),
    })
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.status.success) {
          // Convert object to array of [key, value] pairs
          const transformedData = Object.entries(result.data).map(
            ([id, code]) => ({
              value: id,
              label: code as string, // explicitly asserting that code is a string
            }),
          );
          setShowBranchSelect(true);
          setBranchsList(transformedData);
        } else {
          console.warn("List of wholesalers not found");
        }
      });
  };

  const nipStatus = (value: any) => {
    setNipState(value);
    if (value?.length == 10 || value?.length == 11) {
      setShowBranchSelect(true);
      loadOptionsBranchStatic(value);
    } else {
      setShowBranchSelect(false);
    }
  };

  const getData = async (payload: any) => {
    appFetch(
      "POST",
      API_URL,
      "/visit/product-set",
      {
        visit: {
          sap: payload,
        },
      },
      token?.uuid ? token?.uuid : false,
      (result: any) => {
        if (result.status && result.status.success) {
          /// DONT TOUCH OLD
          // console.log("💀💀💀💀", result.data);
          // setAvailableSets(result.data);
          // console.log("💀", Object.keys(result.data));
          // if (Object.keys(result.data).includes("zestaw_3")) {
          //   setAvailableSet1(true);
          // }
          // if (Object.keys(result.data).includes("zestaw_4")) {
          //   setAvailableSet2(true);
          // }

          // NEW
          setAvailableProducts(result.data);

          setStep(step + 1);
        } else {
        }
      },
      () => {},
    );
    console.log(payload);
  };

  return (
    <PageLayout>
      <div className="page NewSaleSerialNumber">
        <div className="heading">
          {step === 1 && (
            <h2 className="title">
              Wybierz numer <br />
              odwiedzonego punktu
            </h2>
          )}
          {step === 2 && <h2 className="title">Rejestracja wizyty</h2>}
          {/* <Title>Rejestracja wizyty</Title> */}
        </div>
        <div className={`device-wrapper step-${step}`}>
          <div className="step-wrapper">
            <span className={step >= 1 ? "step active" : "step"}>1</span>
            <span className={step >= 2 ? "step active" : "step"}>2</span>
          </div>

          {/* {...register("serial", {required: true, minLength: 1, maxLength: 64})} */}
          {step === 1 && (
            <>
              <div className="input-item">
                <label htmlFor="nip">NIP Punktu</label>
                <input
                  className={errors.serial && "error-input"}
                  type="text"
                  id="nip"
                  {...register("nip", {
                    required: true,
                    minLength: 10,
                    maxLength: 11,
                  })}
                  placeholder="Wpisz NIP punktu sprzedaży"
                  onChange={(e) => nipStatus(e.target.value)}
                ></input>
                {errors.nip && errors.nip.type === "minLength" && (
                  <p className="error">Nieprawidłowa wartość</p>
                )}
                {errors.nip && errors.nip.type === "required" && (
                  <p className="error">Wpisz numer seryjny produktu</p>
                )}
                {errors.nip && errors.nip.type === "maxLength" && (
                  <p className="error">Maksymalnie 64 znaki</p>
                )}
              </div>

              <div className="input-item">
                <label htmlFor="branchName">
                  Numer Fizyczny Punktu <br />
                  <span>(Kod otrzymasz od Przedstawiciela)</span>
                </label>
                <Controller
                  name="branchName"
                  control={control}
                  rules={{ required: "Nazwa oddziału jest wymagana" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={branchsList}
                      ref={selectInputRef}
                      isDisabled={!showBranchSelect}
                      className={
                        errors.branchName
                          ? "error-input businessName"
                          : "businessName"
                      }
                      placeholder="Wybierz numer ID punktu sprzedaży"
                      noOptionsMessage={() => "Brak oddziału o podanym NIPie"}
                      onChange={(selectedOption) => {
                        setUuidSelected(selectedOption.value);
                        field.onChange(selectedOption);
                      }}
                    />
                  )}
                />
                {errors?.branchName && <p className="error">Pole wymagane</p>}
              </div>

              <Button
                disabled={!Boolean(uuidSelected)}
                color={Boolean(uuidSelected) ? "blue" : "grey"}
                onClick={() => {
                  getData(uuidSelected);

                  // @ts-ignore

                  // registerVisit(uuidSelected);
                }}
              >
                Potwierdzam
              </Button>
              <p className="disclamer">
                W przypadku braku odwiedzonego punktu sprzedaży, uprzejmie
                <br />
                prosimy o kontakt pod adresem e-mail: kontakt@batpartners.pl
              </p>
            </>
          )}
          {step === 2 && (
            <PackhotsProductSelect
              uuidSelected={uuidSelected}
              availableProducts={availableProducts}
              onSubmit={(selected: any) =>
                registerVisit(uuidSelected, selected)
              }
            />
          )}
          {/* <div className="input-item">
            <label htmlFor="serial">
              Numer Fizyczny Punktu
              <br />
              <span>(Kod otrzymasz od przedstawiciela)</span>
            </label>
            <input
              className={errors.serial && "error-input"}
              type="text"
              id="serial"
              {...register("serial", {
                required: true,
                minLength: 1,
                maxLength: 64,
              })}
              placeholder="Wybierz numer ID punktu sprzedaży"
              onChange={(e) => setNfpState(e.target.value)}
            ></input>
            {errors.serial && errors.serial.type === "minLength" && (
              <p className="error">Nieprawidłowa wartość</p>
            )}
            {errors.serial && errors.serial.type === "required" && (
              <p className="error">Wpisz numer seryjny produktu</p>
            )}
            {errors.serial && errors.serial.type === "maxLength" && (
              <p className="error">Maksymalnie 64 znaki</p>
            )}
          </div> */}
        </div>
      </div>
    </PageLayout>
  );
}

export default NewSaleSerialNumber;
